module.exports = __webpack_public_path__ + "static/media/the-etho-verified.8973171d.png";